import { createContext, useContext } from 'react';

/**
 * This context functions as our service registry, allowing consuming components to access services.
 */
export interface AppContextValue {
    /**
     * Shows an error message as a toast notification
     * @param message The error message
     * @param error The error source
     */
    showErrorNotification(message: string, error?: any): void;

    /**
     * Produces a promise error response handler that instructs the application to display the
     * error in the manner of its choosing.
     * Today this will result in a toast error message being displayed.
     *
     * @param message The high-level error message. e.g. "Failed to update schedule"
     */
    showErrorHandler(message: string): (error: any) => Promise<never>;
}

export const AppContext = createContext<AppContextValue>({
    showErrorNotification: () => {},
    showErrorHandler: () => async () => {
        return Promise.reject();
    },
});

export function useAppContext(): AppContextValue {
    return useContext(AppContext);
}
